export default "__VITE_ASSET__BuqdIGVe__"